import { Tooltip } from "antd";

// The lists' "Created via AI" filter: `createdVia=ai` shows the drafts an AI
// assistant made that nobody has published or discarded yet. Publication and
// discard clear the marker, so a published item carries neither this label
// nor a match for the filter. A flag filter: picking it applies `value` at
// once, there is nothing further to choose.
export const CREATED_VIA_FILTER = { name: "Created via AI", id: "createdVia", flag: true, value: "ai" };

// The API supplies provenance for the editable draft, not the published row.
// Keep client/author text as React text; never render it as markup.
export default function AiDraftLabel({ record }) {
  if (!record?.createdViaClient) return null;
  const author = record.createdViaAuthorName || record.User?.fullName;
  return (
    <Tooltip title={`Created via AI: ${record.createdViaClient}`}>
      {/* Same look as a table cell's subtext (.lf-table-cell__subtext), kept
          inline because the editor renders it outside the tables' stylesheet. */}
      <span style={{ display: "block", color: "var(--text-2)", fontSize: 12, lineHeight: 1, marginTop: 5 }}>
        {author ? `Created via AI by ${author}` : "Created via AI"}
      </span>
    </Tooltip>
  );
}
